import React from 'react';

interface SystemSetupCardProps {
  assessmentTitle?: string;
  totalPoints?: number;
  durationMinutes?: number;
}

export const SystemSetupCard: React.FC<SystemSetupCardProps> = ({
  assessmentTitle = 'HiAcuity Assessment',
  totalPoints = 2,
  durationMinutes = 60,
}) => {
  const pad = (n: number) => String(n).padStart(2, '0');
  const hours = Math.floor(durationMinutes / 60);
  const mins = durationMinutes % 60;
  const durationLabel = `${pad(hours)}:${pad(mins)} minutes`;

  return (
    <div className='w-full rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden text-left'>

      { /* Modal-style header */ }
      <div className='flex items-center justify-between px-5 py-3.5 border-b border-gray-100'>
        <span className='text-sm font-semibold text-gray-800'>{ assessmentTitle }</span>
        <div className='w-7 h-7 rounded-full bg-red-100 flex items-center justify-center'>
          <svg className='w-3.5 h-3.5 text-red-400' fill='none' stroke='currentColor' strokeWidth={2.5} viewBox='0 0 24 24'>
            <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
          </svg>
        </div>
      </div>

      { /* Body */ }
      <div className='px-6 py-5 flex flex-col gap-3'>

        { /* Assessment name */ }
        <p className='text-[13px] font-semibold text-gray-700'>{ assessmentTitle }</p>

        { /* Points & Duration row */ }
        <div className='flex items-center gap-6'>
          { /* Points */ }
          <div className='flex items-center gap-1.5'>
            <svg className='w-4 h-4 text-blue-500' fill='none' stroke='currentColor' strokeWidth={1.8} viewBox='0 0 24 24'>
              <rect x='3' y='11' width='18' height='11' rx='2' />
              <path strokeLinecap='round' strokeLinejoin='round' d='M7 11V7a5 5 0 0110 0v4' />
            </svg>
            <span className='text-[13px] font-semibold text-blue-600'>
              Total: { totalPoints } { totalPoints === 1 ? 'point' : 'points' }
            </span>
          </div>

          { /* Duration */ }
          <div className='flex items-center gap-1.5'>
            <svg className='w-4 h-4 text-gray-400' fill='none' stroke='currentColor' strokeWidth={1.8} viewBox='0 0 24 24'>
              <circle cx='12' cy='12' r='9' />
              <path strokeLinecap='round' strokeLinejoin='round' d='M12 7v5l3 3' />
            </svg>
            <span className='text-[13px] text-gray-500'>
              Duration: { durationLabel }
            </span>
          </div>
        </div>

        { /* Divider */ }
        <div className='border-t border-gray-100' />

        { /* Disclaimer */ }
        <p className='text-[12px] text-gray-500 leading-relaxed'>
          Disclaimer: During the process of the assessment your browser actions will be
          monitored.
        </p>

        { /* Warning */ }
        <p className='text-[12px] font-medium text-red-500 leading-relaxed'>
          Warning: Once you start the assessment, you must complete it and you cannot
          re&#8209;take it again.
        </p>

        { /* Start button */ }
        <div className='flex justify-end pt-1'>
          <div
              className='px-5 py-2 rounded-lg text-[12px] font-semibold text-white select-none'
              style={{ background: 'linear-gradient(135deg, #059669 0%, #047857 100%)' }}
          >
            Start Assessment
          </div>
        </div>
      </div>
    </div>
  );
};
